import { useState, useEffect } from 'react';
import axios from 'axios';

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setErrorMessage('?? Authentication error: Please log in.');
      console.error('JWT token not found in local storage');
      return;
    }

    try {
      const response = await axios.get('https://plateformewmg.cloud/api/announcement', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (Array.isArray(response.data)) {
        setAnnouncements(response.data);
        setErrorMessage('');
      } else {
        setAnnouncements([]);
        setErrorMessage('');
      }
    } catch (error) {
      setErrorMessage('?? Error fetching announcements. Please try again later.');
      console.error('Error fetching announcements:', error);
    }
  };

  return (
    <div>
      {errorMessage ? (
        <div style={{
          backgroundColor: '#133b8c',
          color: 'white',
          padding: '10px',
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: '20px',
        }}>
          {errorMessage}
        </div>
      ) : announcements.length > 0 ? (
        <div style={{
          backgroundColor: '#133b8c',
          padding: '10px',
          color: 'white',
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: '20px',
          lineHeight: '1.5',
        }}>
          {announcements.map((ann) => (
            <div key={ann.id} style={{ marginBottom: '8px' }}>
              <strong>{ann.title}:</strong> {ann.message}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default AnnouncementBanner;
